import { getHeaders, mlyApi } from "config/mlyApi";

export async function getSsos() {
  const requestConfig = await getHeaders();
  const url = "/ssos";
  return mlyApi.get(url, requestConfig);
}
